// extracted by mini-css-extract-plugin
module.exports = {"not-found":"_8810c1","not-found__header":"_8875bb","not-found__desc":"_652936"};